const DICE_NAMES_AR = ['', 'واحد', 'تنين', 'تلاتة', 'أربعة', 'خمسة', 'ستة'];

export function rollDice(): number[] {
  const d1 = Math.ceil(Math.random() * 6);
  const d2 = Math.ceil(Math.random() * 6);
  return d1 === d2 ? [d1, d1, d1, d1] : [d1, d2];
}

// Animate dice elements, then snap to final values.
// diceEls must already exist in the DOM.
export async function animateRoll(
  diceEls: HTMLElement[],
  finalValues: number[],
): Promise<void> {
  const DURATION_MS = 800;
  const TICK_MS = 80;
  const ticks = Math.round(DURATION_MS / TICK_MS);

  for (let i = 0; i < ticks; i++) {
    for (const el of diceEls) {
      el.textContent = String(Math.ceil(Math.random() * 6));
      el.classList.add('rolling');
    }
    await delay(TICK_MS);
  }

  for (let i = 0; i < diceEls.length; i++) {
    const el = diceEls[i]!;
    el.classList.remove('rolling');
    el.textContent = String(finalValues[i] ?? finalValues[0]);
  }
}

export function callOutDice(values: number[]): void {
  // Use unique die faces only for callout (doubles: call once)
  const unique = [...new Set(values)];
  unique.forEach((v, i) => {
    try {
      const audio = new Audio(`audio/dice-${DICE_NAMES_AR[v] ?? v}.mp3`);
      setTimeout(() => { audio.play().catch(() => { /* missing file */ }); }, i * 600);
    } catch {
      // audio not available
    }
  });
}

function delay(ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms));
}
